var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCareProgrampdpdrawer = function SvgCareProgrampdpdrawer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.927 16.216c-.033-1.495-.064-2.908-.064-4.268 0-2.06-1.973-3.734-4.396-3.734-9.38 0-16.499-2.272-22.404-7.15-1.718-1.419-4.41-1.419-6.13 0-5.903 4.878-13.022 7.15-22.4 7.15C2.11 8.214.137 9.89.137 11.948c0 1.388-.032 2.815-.066 4.326-.159 7.054-.356 15.833 3.112 23.802 1.907 4.382 4.794 8.19 8.582 11.318 4.314 3.563 9.964 6.39 16.793 8.4.465.137.95.206 1.44.206.491 0 .977-.07 1.44-.206 6.83-2.01 12.48-4.837 16.795-8.4 3.788-3.129 6.675-6.937 8.583-11.318 3.469-7.97 3.271-16.749 3.113-23.803l-.002-.057Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.16 24.995c0 10.655-12.59 17.684-16.422 19.552-.657.33-1.533.33-2.19 0-3.832-1.868-16.423-8.678-16.423-19.552 0-5.492 4.05-9.995 8.978-9.995 3.941 0 7.226 2.746 8.43 6.59 1.204-3.844 4.599-6.59 8.43-6.59 5.146 0 9.197 4.503 9.197 9.995Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "careProgrampdpdrawer_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 15,
    width: 36,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.16 24.995c0 10.655-12.59 17.684-16.422 19.552-.657.33-1.533.33-2.19 0-3.832-1.868-16.423-8.678-16.423-19.552 0-5.492 4.05-9.995 8.978-9.995 3.941 0 7.226 2.746 8.43 6.59 1.204-3.844 4.599-6.59 8.43-6.59 5.146 0 9.197 4.503 9.197 9.995Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#careProgrampdpdrawer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.035 28.745c0 10.655-12.59 17.684-16.422 19.552-.657.33-1.533.33-2.19 0C27.59 46.429 15 39.619 15 28.745c0-5.492 4.05-9.995 8.978-9.995 3.941 0 7.226 2.746 8.43 6.59 1.204-3.844 4.599-6.59 8.43-6.59 5.146 0 9.197 4.503 9.197 9.995Z",
    fill: "#40B6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.518 44.097-.005.003a2.05 2.05 0 0 1-1.741 0l-.005-.003c-1.9-.925-5.956-3.07-9.531-6.319-3.581-3.253-6.611-7.55-6.611-12.783 0-5.267 3.876-9.495 8.478-9.495 3.691 0 6.804 2.572 7.953 6.24a.5.5 0 0 0 .954 0c1.148-3.664 4.368-6.24 7.954-6.24 4.828 0 8.696 4.236 8.696 9.495 0 5.122-3.028 9.419-6.612 12.702-3.577 3.277-7.634 5.477-9.53 6.4Z",
    stroke: "#222",
    strokeLinejoin: "round"
  }))));
};
export default SvgCareProgrampdpdrawer;